<template>
  <b-modal
    v-model="visible"
    title="Filtrar análises"
    centered
    @ok="handleApply"
  >
    <b-form-group label="Proposta">
      <b-form-select
        v-model="localFilters.proposal"
        :options="creditProducts"
      />
    </b-form-group>

    <b-form-group label="Data da análise">
     <b-form-input
        v-model="localFilters.analysisDate"
        type="date"
        :max="today"
        autocomplete="off"
      />
    </b-form-group>

    <b-form-group label="Status">
      <b-form-select
        v-model="localFilters.approved"
        :options="statusOptions"
      />
    </b-form-group>

    <b-form-group label="Responsável da análise">
      <b-form-select
        v-model="localFilters.responsible"
        :options="responsibleOptions"
      />
    </b-form-group>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="outline-secondary"
        @click="handleClear(cancel)"
      >
        Limpar
      </b-button>

      <b-button
        variant="primary"
        @click="handleApplyClick(ok)"
      >
        Aplicar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BFormGroup,
  BFormInput,
  BFormSelect
} from 'bootstrap-vue'
import { DateTime } from 'luxon'

export default {
  name: 'AnalysisFilterModal',

  components: {
    BModal,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    filters: {
      type: Object,
      default: () => ({
        proposal: '',
        analysisDate: '',
        approved: '',
        responsible: ''
      })
    },

    creditProducts: {
      type: Array,
      default: () => []
    },

    statusOptions: {
      type: Array,
      default: () => []
    },
    
    responsibleOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localFilters: {
        proposal: '',
        analysisDate: '',
        approved: '',
        responsible: ''
      }
    }
  },

  computed: {
    today() {
      return DateTime.local().toISODate()
    },

    visible: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          this.syncFilters()
        }
      }
    },

    filters: {
      deep: true,
      handler() {
        if (this.value) {
          this.syncFilters()
        }
      }
    }
  },

  methods: {
    syncFilters() {
      this.localFilters = {
        proposal: '',
        analysisDate: '',
        approved: '',
        responsible: '',
        ...this.filters
      }
    },

    handleApply() {
      this.$emit('apply', {
        ...this.localFilters
      })
    },

    handleApplyClick(ok) {
      if (this.localFilters.analysisDate > this.today) {
        this.localFilters.analysisDate = ''
        this.$toast.error('A data da análise não pode ser futura.')
        return
      }

      ok()
    },

    handleClear(cancel) {
      this.localFilters = {
        proposal: '',
        analysisDate: '',
        approved: '',
        responsible: ''
      }

      this.$emit('clear')
      cancel()
    }
  }
}
</script>

<style scoped>
.form-control:focus,
.custom-select:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}
</style>